
class DownloadService {
  pad = (number) => String(number).padStart(2, '0')

  rawTimestamp (date) {
    const hours = this.pad(date.getHours())
    const minutes = this.pad(date.getMinutes())
    const seconds = this.pad(date.getSeconds())
    return `${hours}${minutes}${seconds}`
  }

  rawDate (date) {
    const year = this.pad(date.getFullYear())
    const month = this.pad(date.getMonth())
    const day = this.pad(date.getDate())
    return `${year}${month}${day}`
  }

  getDownloadFileName (fileNamePrefix, format = 'json') {
    const timeStr = this.rawTimestamp(new Date())
    const dateStr = this.rawDate(new Date())
    return `${fileNamePrefix}_${dateStr}_${timeStr}.${format}`
  }

  downloadContent (fileNamePrefix, content) {
    const fileURL = window.URL.createObjectURL(new Blob([content]))
    const a = document.createElement('a')

    a.href = fileURL
    a.style.display = 'none'
    a.setAttribute('download', this.getDownloadFileName(fileNamePrefix))
    document.body.appendChild(a)

    a.click()
    a.remove()
  }
}

export default new DownloadService()
